import { Injectable } from '@angular/core';
const TOKEN_KEY = 'KenindiaBusinessToken';
const REFRESH_TOKEN = 'Refresh-Token';
const CUSTOMER_TOKEN='Customer-Token'
@Injectable({
  providedIn: 'root'
})
export class TokenStorageService{


  save(token: any) {
    window.localStorage[TOKEN_KEY] = token;
  }

  get() {
    if (window.localStorage[TOKEN_KEY]) {
      return window.localStorage[TOKEN_KEY];
    } else {
      return ''
    }
  }

  destroy() {
    window.localStorage.removeItem(TOKEN_KEY);
  }
  saveRT(token: any) {
    window.localStorage[REFRESH_TOKEN] = token;
  }
  getRT() {
    if (window.localStorage[REFRESH_TOKEN]) {
      return window.localStorage[REFRESH_TOKEN];
    } else {
      return ''
    }
  }
  destroyRT() {
    window.localStorage.removeItem(CUSTOMER_TOKEN);
  }
  // saveCT(token: any) {
  //   window.localStorage[CUSTOMER_TOKEN] = token;
  // }
  // getCT() {
  //   if (window.localStorage[CUSTOMER_TOKEN]) {
  //     return window.localStorage[CUSTOMER_TOKEN];
  //   } else {
  //     return ''
  //   }
  // }
  // destroyCT() {
  //   window.localStorage.removeItem(CUSTOMER_TOKEN);
  // }
}
